import { utils, Contract } from 'ethers';

/* Autogenerated file. Do not edit manually. */
var _abi = [{
  type: "event",
  anonymous: false,
  name: "LogBeneficiaryUpdated",
  inputs: [{
    type: "address",
    name: "token",
    indexed: true
  }, {
    type: "address",
    name: "vestingBeneficiary",
    indexed: false
  }]
}, {
  type: "event",
  anonymous: false,
  name: "LogTokenAdded",
  inputs: [{
    type: "address",
    name: "token",
    indexed: true
  }, {
    type: "address",
    name: "vestingBeneficiary",
    indexed: false
  }, {
    type: "uint256",
    name: "vestingPeriodInDays",
    indexed: false
  }]
}, {
  type: "event",
  anonymous: false,
  name: "OwnershipTransferred",
  inputs: [{
    type: "address",
    name: "previousOwner",
    indexed: true
  }, {
    type: "address",
    name: "newOwner",
    indexed: true
  }]
}, {
  type: "event",
  anonymous: false,
  name: "Released",
  inputs: [{
    type: "address",
    name: "token",
    indexed: true
  }, {
    type: "address",
    name: "vestingBeneficiary",
    indexed: false
  }, {
    type: "uint256",
    name: "amount",
    indexed: false
  }]
}, {
  type: "function",
  name: "DAYS_IN_SECONDS",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [],
  outputs: [{
    type: "uint256"
  }]
}, {
  type: "function",
  name: "addToken",
  constant: false,
  payable: false,
  inputs: [{
    type: "address",
    name: "_token"
  }, {
    type: "address[3]",
    name: "_beneficiaries"
  }, {
    type: "uint256[3]",
    name: "_proportions"
  }, {
    type: "uint256",
    name: "_vestingPeriodInDays"
  }],
  outputs: []
}, {
  type: "function",
  name: "beneficiaries",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [{
    type: "address"
  }, {
    type: "uint256"
  }],
  outputs: [{
    type: "address",
    name: "beneficiary"
  }, {
    type: "uint256",
    name: "proportion"
  }, {
    type: "uint256",
    name: "streamId"
  }, {
    type: "uint256",
    name: "remaining"
  }]
}, {
  type: "function",
  name: "beneficiaryTokens",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [{
    type: "address"
  }, {
    type: "uint256"
  }],
  outputs: [{
    type: "address"
  }]
}, {
  type: "function",
  name: "getAllTokensByBeneficiary",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [{
    type: "address",
    name: "_beneficiary"
  }],
  outputs: [{
    type: "address[]"
  }]
}, {
  type: "function",
  name: "getVestingInfo",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [{
    type: "address",
    name: "_token"
  }],
  outputs: [{
    type: "tuple",
    components: [{
      type: "address",
      name: "vestingBeneficiary"
    }, {
      type: "uint256",
      name: "totalBalance"
    }, {
      type: "uint256",
      name: "beneficiariesCount"
    }, {
      type: "uint256",
      name: "start"
    }, {
      type: "uint256",
      name: "stop"
    }]
  }]
}, {
  type: "function",
  name: "owner",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [],
  outputs: [{
    type: "address"
  }]
}, {
  type: "function",
  name: "release",
  constant: false,
  payable: false,
  inputs: [{
    type: "address",
    name: "_token"
  }, {
    type: "address",
    name: "_beneficiary"
  }],
  outputs: []
}, {
  type: "function",
  name: "releaseAll",
  constant: false,
  payable: false,
  inputs: [{
    type: "address",
    name: "_beneficiary"
  }],
  outputs: []
}, {
  type: "function",
  name: "releaseableAmount",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [{
    type: "address",
    name: "_token"
  }],
  outputs: [{
    type: "uint256"
  }]
}, {
  type: "function",
  name: "releaseableAmountByAddress",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [{
    type: "address",
    name: "_token"
  }, {
    type: "address",
    name: "_beneficiary"
  }],
  outputs: [{
    type: "uint256"
  }]
}, {
  type: "function",
  name: "renounceOwnership",
  constant: false,
  payable: false,
  inputs: [],
  outputs: []
}, {
  type: "function",
  name: "setSablier",
  constant: false,
  payable: false,
  inputs: [{
    type: "address",
    name: "_sablier"
  }],
  outputs: []
}, {
  type: "function",
  name: "setVestingAddress",
  constant: false,
  payable: false,
  inputs: [{
    type: "address",
    name: "_vestingBeneficiary"
  }, {
    type: "address",
    name: "_token"
  }, {
    type: "address",
    name: "_newVestingBeneficiary"
  }],
  outputs: []
}, {
  type: "function",
  name: "setVestingReferral",
  constant: false,
  payable: false,
  inputs: [{
    type: "address",
    name: "_vestingBeneficiary"
  }, {
    type: "address",
    name: "_token"
  }, {
    type: "address",
    name: "_vestingReferral"
  }],
  outputs: []
}, {
  type: "function",
  name: "transferOwnership",
  constant: false,
  payable: false,
  inputs: [{
    type: "address",
    name: "newOwner"
  }],
  outputs: []
}, {
  type: "function",
  name: "vestedAmount",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [{
    type: "address",
    name: "_token"
  }],
  outputs: [{
    type: "uint256"
  }]
}, {
  type: "function",
  name: "vestingInfo",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [{
    type: "address"
  }],
  outputs: [{
    type: "address",
    name: "vestingBeneficiary"
  }, {
    type: "uint256",
    name: "totalBalance"
  }, {
    type: "uint256",
    name: "beneficiariesCount"
  }, {
    type: "uint256",
    name: "start"
  }, {
    type: "uint256",
    name: "stop"
  }]
}];
var TokenVesting__factory = /** @class */function () {
  function TokenVesting__factory() {}
  TokenVesting__factory.createInterface = function () {
    return new utils.Interface(_abi);
  };
  TokenVesting__factory.connect = function (address, signerOrProvider) {
    return new Contract(address, _abi, signerOrProvider);
  };
  TokenVesting__factory.abi = _abi;
  return TokenVesting__factory;
}();

export { TokenVesting__factory };
